/** @format */

import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from 'react-router-dom';
import Login from '../pages/login/login';
import Header from '../components/header/header';
import UserConfirmation from '../pages/user-confirmation/user-confirmation';
import AddressConfirmation from '../pages/address-confirmation/address-confirmation';
import TermsAndConditions from '../pages/terms-and-conditions/terms-and-conditions';
import TestLauncher from '../pages/test-launcher/test-launcher';
import Exit from '../pages/exit/exit';
import NotFound from '../pages/not-found/not-found';
import './layout.scss';

class Layout extends React.Component {
  render() {
    return (
      <Router>
        <Header />
        <div className="layout-container">
          <Switch>
            <Route
              exact
              path="/"
              render={props => (
                <Redirect
                  {...props}
                  to={{
                    pathname: '/center/login',
                    search: props.location.search,
                  }}
                />
              )}
            ></Route>
            <Route
              exact
              path="/login"
              render={props => (
                <Redirect
                  {...props}
                  to={{
                    pathname: '/center/login',
                    search: props.location.search,
                  }}
                />
              )}
            ></Route>
            <Route
              exact
              path="/center/login"
              history
              render={props => <Login {...props} isRemote={false} />}
            ></Route>
            <Route
              exact
              path="/remote/login"
              render={props => <Login {...props} isRemote={true} />}
            ></Route>
            <Route
              exact
              path="/user-confirmation"
              component={UserConfirmation}
            ></Route>
            <Route
              exact
              path="/address-confirmation"
              component={AddressConfirmation}
            ></Route>
            <Route
              exact
              path="/terms-and-conditions"
              component={TermsAndConditions}
            ></Route>
            <Route exact path="/test-launcher" component={TestLauncher}></Route>
            <Route exact path="/exit" component={Exit}></Route>
            <Route component={NotFound} />
          </Switch>
        </div>
      </Router>
    );
  }
}
export default Layout;
